// extracted by mini-css-extract-plugin
module.exports = {"info":"info___17f_C","tag":"tag___2duyq"};